import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, throwError } from 'rxjs';
import { saveParams } from './df-mapping-changes.component';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';


@Injectable({
  providedIn: 'root'
})
export class DfMappingChangesService {
	url ={
		insertNaicsCode: '/saveJsonObject?action_code=304rqd'
	}

	constructor(private httpClient: HttpClient, private http:HttpClient, private gtwSnackbarService: GtwSnackbarService) { }

	saveLineChanges(baseURL : string, params: saveParams, jsonSettings: saveParams, jsonData: any, scenarioCode: string, isIssueKeyEnabled: string, issueKey: number) {

		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/x-www-form-urlencoded');
		
		headers.append('withCredentials', 'true');

		let body = new FormData();
		body.append('clob_settings', JSON.stringify([jsonSettings]));
		body.append('clob_data', JSON.stringify(jsonData));
		body.append('tax_year', params.tax_year ? params.tax_year.toString() : '');
		body.append('scenario', params.scenario ? params.scenario.toString() : '');
		body.append('jcd_key', params.jcd_key ? params.jcd_key.toString() : '');
        body.append('process_name', 'update-df-mapping');
		body.append('is_issue_key_enabled', isIssueKeyEnabled);
		body.append('issue_key', issueKey.toString());
		body.append('scenarioCode', scenarioCode);


		const url = `${baseURL}${this.url.insertNaicsCode}`;


		return this.httpClient.post(url, body, { headers }).pipe(
			map((res:any) => { 
				if(res.callSuccess == "1"){
					if(res.errorMessage != "null"){
						this.gtwSnackbarService.openSnackBar(res.errorMessage, 'gtw-snackbar--red');
					}
					this.gtwSnackbarService.openSnackBar("Data Saved Successfully", 'gtw-snackbar--green');
					return res;
				}else{
					this.gtwSnackbarService.openSnackBar(res.errorMessage, 'gtw-snackbar--red');
					return "error";
				}
				throwError(new Error('oops!'));
				return null;
			}
		));
	}

}
